module.exports = __webpack_public_path__ + "img/002.78af9b2e.jpg";